import { combineReducers } from "redux";

import countyConfigReducer from "./countyConfigReducer"; // ??

// Object Types
import auditLogTypesAllReducer from "./auditLogTypesAllReducer";
import auditLogTypesReducer from "./auditLogTypesReducer";

import userTypesReducer from "./userTypesReducer";

// LS County Config
import countyConfigReportsReducer from "./countyConfigReportsReducer"; 
import countyConfigLanguagesReducer from "./countyConfigLanguagesReducer"; 
import countyConfigCommonReducer from "./countyConfigCommonReducer";
import countyConfigAlertSettingsReducer from "./countyConfigAlertSettingsReducer";
import countyConfigUserAccessReducer from "./countyConfigUserAccessReducer";
import countyConfigLoginRegistrationReducer from "./countyConfigLoginRegistrationReducer";
import countyConfigMultiTenantSettingsReducer from "./countyConfigMultiTenantSettingsReducer";

// As defined in LS Server product.propertes
import productPropertiesReducer from "./productPropertiesReducer";

// LS Lockout
import countyConfigUserLockoutReducer from "./countyConfigUserLockoutReducer";

// Current User
import currentUserReducer from "./currentUserReducer";

// Criteria
import reportCriteriaReducer from "./reportCriteriaReducer";

// Alert and User Lists
import alertListFiltersReducer from './alertListFiltersReducer';
import userListFiltersReducer from './userListFiltersReducer';
import administratorListFiltersReducer from './administratorListFiltersReducer';
import emailAddressListFiltersReducer from './emailAddressListFiltersReducer';

import userViewSelectedAlertReducer from './userViewSelectedAlertReducer';

// Paginators
import alertsPaginationReducer from './alertsPaginationReducer';
import alertsPaginationTenantAdminReducer from './alertsPaginationTenantAdminReducer';
import userSelectionListPaginationReducer from './userSelectionListPaginationReducer';
import usersPaginationReducer from './usersPaginationReducer';
import usersPaginationTenantAdminReducer from './usersPaginationTenantAdminReducer';
import emailAddressSelectionListPaginationReducer from "./emailAddressSelectionListPaginationReducer";
import emailAddressesPaginationReducer from "./emailAddressesPaginationReducer";
import emailAddressesPaginationTenantAdminReducer from "./emailAddressesPaginationTenantAdminReducer";
import phoneSelectionListPaginationReducer from "./phoneSelectionListPaginationReducer";
import phonesPaginationReducer from "./phonesPaginationReducer";
import phonesPaginationTenantAdminReducer from "./phonesPaginationTenantAdminReducer";
import fileUploadsPaginationTenantAdminReducer from "./fileUploadsPaginationTenantAdminReducer";
import administratorsPaginationTenantAdminReducer from "./administratorsPaginationTenantAdminReducer";

// Search page, Report page and Control Panel page selections
import controlPanelTypeReducer from "./controlPanelTypeReducer";

import tenantAdminTypeReducer from "./tenantAdminTypeReducer";

// Side Navigation
import sideNavigationReducer from "./sideNavigationReducer";

// Server Product Versions
import serverProductVersionsReducer from "./serverProductVersionsReducer";

// Translations
import translationsReducer from './translationsReducer';
import languageReducer from './languageReducer';

const appReducer = combineReducers({

	countyConfigReducer, 
	
	// Object Types
	auditLogTypesReducer,
	auditLogTypesAllReducer,
	
	userTypesReducer,
	
	// LS Control Panel
	countyConfigCommonReducer,
	countyConfigAlertSettingsReducer,
	countyConfigLanguagesReducer,

	countyConfigReportsReducer,
	countyConfigUserAccessReducer,
	countyConfigLoginRegistrationReducer,
	countyConfigMultiTenantSettingsReducer,

	// LS Server product.properties
	productPropertiesReducer,

	// LS Lockout
	countyConfigUserLockoutReducer,

	// Current User
	currentUserReducer,

	// Criteria	
	reportCriteriaReducer,

	// Alert and User Selectors
	alertListFiltersReducer,
	userListFiltersReducer,
	administratorListFiltersReducer,

	emailAddressListFiltersReducer,
	userViewSelectedAlertReducer,

	// Pagination
	alertsPaginationReducer,
	alertsPaginationTenantAdminReducer,
	userSelectionListPaginationReducer,
	usersPaginationReducer,
	usersPaginationTenantAdminReducer,
	emailAddressesPaginationReducer,
	emailAddressesPaginationTenantAdminReducer,
	phonesPaginationReducer,
	phonesPaginationTenantAdminReducer,
	fileUploadsPaginationTenantAdminReducer,
	administratorsPaginationTenantAdminReducer,

	// Selection Lists
	emailAddressSelectionListPaginationReducer,
	phoneSelectionListPaginationReducer,

	// Control Panel page selections
	controlPanelTypeReducer,

	// Tenant Admin page selections
	tenantAdminTypeReducer,
	
	// Side Navigation
	sideNavigationReducer,

	// Server Product Versions
	serverProductVersionsReducer,

	// Translations
	translationsReducer,
	languageReducer

});

const rootReducer = (state, action) => {
	if (action.type === 'USER_LOGOUT') { // LOGOUT_USER
		return appReducer(undefined, action)
	}
	return appReducer(state, action)
}

export default rootReducer;